module.exports = __webpack_public_path__ + "static/media/work-img4-1.17d65309.png";